<template>
  <div class="syncSide" v-if="print_areas.length !== 1">
    <a-dropdown>
      <a>{{ $t('design.copyFace') }}</a>
      <a-menu slot="overlay">
        <a-menu-item>
          <a target="_blank" rel="noopener noreferrer" @click="syncSide(0)">{{ $t('design.copyToAllFaces') }}</a>
        </a-menu-item>
        <a-menu-item v-for="(value, index) in print_areas" :key="index">
          <a
            target="_blank"
            rel="noopener noreferrer"
            :disabled="activeDesign === value.view_id"
            @click="syncSide(value.view_id)"
            >{{ $t('design.copyToFace') }}{{ value.view_id }}</a
          >
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import { transformJSON } from '@/utils/util'
import * as cc from 'my-design-canvas/desf4fc'
export default {
  name: 'SyncSide',
  methods: {
    ...mapMutations({
      setRandom: 'SET_RANDOM'
    }),
    syncSide(viewId) {
      const designParams = this.activeFabric.toJSON([
        'material_code',
        'oss_file_id',
        'material_id',
        'style',
        'time',
        'removed',
        'groupType',
        'paddingX',
        'paddingY',
        'pxH',
        'pxW',
        'vision_oss_file_id',
        'vision_type',
        'uuid'
      ])
      if (viewId !== 0) {
        const copySide = this.fabricList.find(item => item.view_id === viewId)
        copySide &&
          copySide.canObj.loadFromJSON(designParams, () => {
            const styleObj = this.print_areas.find(it => {
              return it.view_id === viewId
            })
            if (styleObj.design_style) {
              const objects = copySide.canObj.getObjects()
              const filter = new cc.Image.filters.BlendColor({
                color: styleObj.design_style,
                mode: 'tint'
              })
              objects.forEach(item => {
                if (item.type === 'image') {
                  item.filters.push(filter)
                  item.applyFilters()
                }
                if (item.type === 'text') {
                  item.set('fill', styleObj.design_style)
                }
                if (item.type === 'group') {
                  const arr = item._objects
                  arr.forEach(it => {
                    it.filters.push(filter)
                    it.applyFilters()
                  })
                }
              })
              copySide.canObj.renderAll()
            }
            this.groupInfo[viewId] = this.activeGroupInfo
            transformJSON(copySide.canObj)
          })
      } else {
        this.fabricList.map(item => {
          item.view_id !== this.activeDesign &&
            item.canObj.loadFromJSON(designParams, () => {
              const styleObj = this.print_areas.find(it => {
                return it.view_id === item.view_id
              })
              if (styleObj.design_style) {
                const objects = item.canObj.getObjects()
                const filter = new cc.Image.filters.BlendColor({
                  color: styleObj.design_style,
                  mode: 'tint'
                })
                objects.forEach(item => {
                  if (item.type === 'image') {
                    item.filters.push(filter)
                    item.applyFilters()
                  }
                  if (item.type === 'text') {
                    item.set('fill', styleObj.design_style)
                  }
                  if (item.type === 'group') {
                    const arr = item._objects
                    arr.forEach(it => {
                      it.filters.push(filter)
                      it.applyFilters()
                    })
                  }
                })
                item.canObj.renderAll()
              }
              this.groupInfo[item.view_id] = this.activeGroupInfo

              transformJSON(item.canObj)
            })
        })
      }
      this.setRandom()
    }
  },
  computed: {
    ...mapState({
      print_areas: state => state.design.print_areas,
      activeDesign: state => state.design.activeDesign,
      fabricList: state => state.design.fabricList,
      groupInfo: state => state.design.groupInfo
    }),
    ...mapGetters(['activeFabric', 'activeGroupInfo'])
  }
}
</script>

<style lang="less" scoped>
.syncSide {
  // position: absolute;
  // top: 0;
  // z-index: 666;
  a {
    color: #666;
  }
}
</style>
